import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIsApplePayActive } from "./use-is-apple-pay-active.js";
import { cartPaymentMethods } from "../../mappers/mappers/cart-payment-methods.js";
import { GET_CART_PAYMENT_METHODS } from "../../operations/queries/operations/queries/get-cart-payment-methods.js";
import { errorsMapping } from "../../mappers/mappers/errors-mapping.js";
const useGetCartPaymentMethods = () => {
  const isApplePayActive = useIsApplePayActive();
  const [getCartPaymentMethods, { called, loading, data, error }] = useLazyQuery(GET_CART_PAYMENT_METHODS, {
    onError(error2) {
      console.error(error2);
      toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }
  });
  const getPaymentMethods = React.useCallback(
    (cartId) => {
      if (cartId) {
        getCartPaymentMethods({ variables: { cartId } });
      }
    },
    [getCartPaymentMethods]
  );
  const queryResults = React.useMemo(
    () => ({
      data: data ? cartPaymentMethods(data, isApplePayActive) : void 0,
      called,
      loading,
      error
    }),
    [called, data, error, loading, isApplePayActive]
  );
  return [getPaymentMethods, queryResults];
};
export {
  useGetCartPaymentMethods
};
//# sourceMappingURL=use-get-cart-payment-methods.js.map
